import { auditApiUrls } from 'constants/apiEndPoints';
import ApiUtil from '../utils/ApiUtil';

const viewUserLogData = async (page: number, size: number): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.getWithToken(`${String(auditApiUrls.auditUser)}?page=${page}&size=${size}`)
            .then((logData) => {
                resolve(logData)
            }).catch((error) => { reject(error); })
    })

const viewEmployeeLogData = async (page: number, size: number): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.getWithToken(`${String(auditApiUrls.auditEmployee)}?page=${page}&size=${size}`)
            .then((logData) => {
                resolve(logData)
            }).catch((error) => { reject(error); })
    })

const viewComplaintLogData = async (page: number, size: number): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.getWithToken(`${String(auditApiUrls.auditComplaint)}?page=${page}&size=${size}`)
            .then((logData) => {
                resolve(logData)
            }).catch((error) => { reject(error); })
    })

const viewChatLogData = async (page: number, size: number): Promise<unknown> => await
    new Promise((resolve, reject) => {

        ApiUtil.getWithToken(`${String(auditApiUrls.auditChat)}?page=${page}&size=${size}`)
            .then((logData) => {
                resolve(logData)
            }).catch((error) => { reject(error); })
    })

const viewTransactionLogData = async (page: number, size: number): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.getWithToken(`${String(auditApiUrls.auditTransaction)}?page=${page}&size=${size}`).then((logData) => {
            resolve(logData)
        }).catch((error) => { reject(error); })

    })

const exportAuditLogsToExcel = async (auditType: string): Promise<unknown> =>
    await new Promise((resolve, reject) => {
        ApiUtil.getExcelFile(`${String(auditApiUrls.auditExport)}${auditType}`)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((res: any) => {
                const blob = new Blob([res.data], { type: res.headers['content-type'] });
                const url = URL.createObjectURL(blob);
                resolve(url);
            })
            .catch((error) => {
                reject(error);
            });
    });

export { viewUserLogData, viewEmployeeLogData, viewComplaintLogData, viewChatLogData, viewTransactionLogData, exportAuditLogsToExcel }